import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { APIMultipartRequest, APIRequest } from '../../common/Common';
import { TARGET_YEAR_API } from '../../common/data';

const initialState = {
  isRender: false,
  reload: -1,
  originList: [],
  resultData: [],

  comYASetting: {},

  tossToken: '',
  installmentData: '', //분납개월수
};

// 증빙서류 메인리스트
export const checkNoPaperCertify = createAsyncThunk('resultQuery/checkNoPaperCertify', async () => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/NoPaperCertify`);
  return response;
});

//전자문서 파일 올렸는지 여부
export const getPDFUploadInfo = createAsyncThunk('resultQuery/getPDFUploadInfo', async () => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/getPDFUploadInfo`);
  return response;
});

export const getComYASetting = createAsyncThunk('resultQuery/getComYASetting', async () => {
  const response = await APIRequest('/YA/getComYASetting');
  return response;
});

//결과상세
export const getResultData = createAsyncThunk('resultQuery/getResultData', async () => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/getResultData`);
  return response;
});

//서명하기
export const signDocument = createAsyncThunk('resultQuery/signDocument', async data => {
  const response = await APIRequest('/YA/signCertifyEnd', data);
  return response;
});

//초기화
export const resetMobileYA = createAsyncThunk('resultQuery/resetMobileYA', async data => {
  const response = await APIRequest('/YA/resetMobileYA', data);
  return response;
});

//세액계산
export const setCalc = createAsyncThunk('resultQuery/setCalc', async () => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/setCalc`);
  return response;
});

//전자문서 확정
export const uploadPDFCommit = createAsyncThunk('resultQuery/uploadPDFCommit', async () => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/pdfcommit`);
  return response;
});

//문자, 이메일인증
export const sendSMS = createAsyncThunk('resultQuery/sendSMS', async params => {
  const response = await APIRequest('/YA/NoPaperCertifySend', params);
  return response;
});

//문자, 이메일 인증체크
export const checkSMS = createAsyncThunk('resultQuery/NoPaperCertifyCheck', async params => {
  const response = await APIRequest('/YA/NoPaperCertifyCheck', params);
  return response;
});

//인증키 체크
export const certifyEnd = createAsyncThunk('resultQuery/NoPaperCertifyEnd', async params => {
  const response = await APIRequest('/YA/NoPaperCertifyEnd', params);
  return response;
});

//카카오톡 인증 전송
export const kakaoCertPrepare = createAsyncThunk('resultQuery/kakaoCertPrepare', async params => {
  const response = await APIRequest('/KakaoCert/kakaoCertPrepare', params);
  return response;
});

//카카오톡 인증 확인
export const kakaoCertStatus = createAsyncThunk('resultQuery/kakaoCertStatus', async params => {
  console.log('카카오톡 인증 확인', params);
  const response = await APIRequest('/KakaoCert/kakaoCertStatus', params);
  return response;
});

//카카오톡/토스 인증 업데이트
export const certifyDateUpdate = createAsyncThunk('resultQuery/certifyDateUpdate', async params => {
  const response = await APIRequest('/YA/certifyDateUpdate', params);
  return response;
});

//토스토큰발급
export const getTossToken = createAsyncThunk('resultQuery/getTossToken', async () => {
  const response = await APIRequest('/TossCert/tossCertGetToken');
  return response;
});

//토스 인증 전송
export const tossCertPrepare = createAsyncThunk('resultQuery/tossCertPrepare', async params => {
  const response = await APIRequest('/TossCert/tossCertPrepare', params);
  return response;
});

//토스 인증 확인
export const tossCertStatus = createAsyncThunk('resultQuery/tossCertStatus', async params => {
  const response = await APIRequest('/TossCert/tossCertStatus', params);
  return response;
});

//분할납부가져오기
export const getInstallment = createAsyncThunk('resultQuery/getInstallment', async () => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/Installment`);
  return response;
});

//분할납부 저장
export const setInstallmentApi = createAsyncThunk('resultQuery/setInstallment', async params => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/Installment`, params);
  return response;
});

const resultQuerySlice = createSlice({
  name: 'resultQuery',
  initialState,
  reducers: {
    resetResultQueryState: () => initialState, // 상태 리셋 액션 추가
    setReload: (state, action) => {
      state.reload = Math.random();
    },
  },
  extraReducers: builder => {
    builder.addCase(checkNoPaperCertify.fulfilled, (state, action) => {
      //증빙서류 메인리스트
      console.log('증빙서류 제출여부', action.payload);
    });
    builder.addCase(getPDFUploadInfo.fulfilled, (state, action) => {
      //증빙서류 메인리스트
      console.log('pdf 업로드 정보', action.payload);
    });
    builder.addCase(getResultData.fulfilled, (state, action) => {
      //결과상세
      console.log('결과상세', action.payload);
      state.resultData = action.payload || [];
    });
    builder.addCase(getTossToken.fulfilled, (state, action) => {
      //토스토큰발급
      console.log('토스토큰발급', action.payload);
      const { resultCode, resultData, resultError } = action.payload;
      if (resultCode == '1') {
        const { access_token } = resultData;
        state.tossToken = access_token || '';
      }
    });
    builder.addCase(getComYASetting.fulfilled, (state, action) => {
      //연말정산 설정
      console.log('연말정산 설정', action.payload);
      state.comYASetting = action.payload || {};
    });
  },
});

export const { resetResultQueryState, setReload } = resultQuerySlice.actions;
export default resultQuerySlice.reducer;
